<template>
    <div id="main">
        <loader v-if="isLoading" />
        <!-- CONTAINER DE ALERTAS -->
        <alert-container :messages="msgs" />
        <div class="listing-header">
            <div class="title-breadcrumb">
                <h1 class="title">
                    {{ $t("vincular-formulario") }}
                </h1>
            </div>
            <div class="header-buttons">
                <button
                    class="save-btn"
                    type="button"
                    @click="save"
                    :disabled="formulariosSelecionados.length === 0"
                >
                    {{ $t("salvar") }}
                </button>
            </div>
        </div>

        <div class="search-and-filter">
            <div class="search-bar">
                <search-bar
                    :onSearch="debouncedOnSearch"
                    tooltipLabel="msg-campo-busca-formulario"
                />
            </div>
        </div>

        <div class="registry-wrapper">
            <empty-table-message v-if="isEmpty" />
            <b-table
                v-else
                :data="formularios"
                class="data-table"
                @sort="sortTable"
                backend-sorting
                checkable
                :checked-rows.sync="formulariosSelecionados"
                :custom-is-checked="(selecionados, linha) => selecionados.id_form_formulario === linha.id_form_formulario"
            >
                <b-table-column
                    v-for="(f, i) in fields"
                    :key="i"
                    :field="f.key"
                    :label="$t(f.key)"
                    :width="f.width"
                    :sortable="f.sortable"
                    :custom-sort="f.sortFn"
                    v-slot="props"
                >
                    <div v-if="f.key == 'obrigatorio'">
                        <b-checkbox v-model="props.row['obrigatorio']"></b-checkbox>
                        {{ $t('sim') }}
                    </div>
                    <div v-else>
                        {{ props.row[f.key] }}
                  </div>
                </b-table-column>
            </b-table>

            <PaginationViewer
                class="mb-0"
                :resetPagination="pagination.resetPagination"
                :totalItems="pagination.totalRows"
                :perPageOptions="pagination.perPageOptions"
                :optionStarted="pagination.optionStarted"
                @change="updatePagination"
            />
        </div>
    </div>
</template>

<script>
// SERVICES
import FormFormularioService from '@/services/AssMotivoAtendimentoFormFormularioService';

// MENSAGENS
import Message from "@/models/Message";

export default {
    data() {
        return {
            service: new FormFormularioService(this.$http, this.$router),
            formularios: [],
            isLoading: false,
            isEmpty: false,
            fields: [
                { key: 'codigo', width: null, sortable: true, sortFn: null },
                { key: 'titulo', width: null, sortable: true, sortFn: null },
                { key: 'obrigatorio', width: null, sortFn: null }
            ],
            formulariosSelecionados: [],
            id_form_formulario: 0,
            debouncedOnSearch: null,
            queryFilter: '',
            pagination: {
                resetPagination: false,
                perPageOptions: [10, 25, 50, 100],
                optionStarted: 0,
                perPage: null,
                totalRows: 0,
                currentPage: 1,
            },
            column: 'titulo',
            order: 'asc',
            msgs: [],
            idMotivoAtendimento: parseInt(this.$route.params.id),
            contexto: '',
        }
    },
    created() {
        this.pagination.perPage = this.pagination.perPageOptions[
            this.pagination.optionStarted
        ];

        this.contexto = this.$route.meta.contexto.slice(0, 3);

        this.debouncedOnSearch = this.debounce(this.onSearch, 500);
        this.carregarDados();
    },
    methods: {
        carregarDados(currentPage = 1) {
            if (currentPage == 1 && this.pagination.currentPage != 1){
                this.pagination.resetPagination = true;
            }

            this.isLoading = true;

            this.service.findFormulariosNaoAssociados(
                this.column,
                this.order,
                currentPage - 1,
                this.pagination.perPage,
                this.idMotivoAtendimento,
                'crm_motivo_atendimento',
                this.contexto,
                this.queryFilter
            )
            .then(this.mapItems)
            .then(value => {
                this.formularios = value;
                this.isEmpty = this.formularios.length === 0;
            })
            .catch(e => {
                this.isEmpty = true;
                this.$root.showMessage('error', 'msg-erro-load');
                console.error('Erro ao carregar os dados.');
            })
            .finally(_ => {
                this.isLoading = false;
                this.pagination.resetPagination = false;
            });
        },
        mapItems(body) {
            this.pagination.totalRows = body.totalElements;
            return body.content.map(ass => {
                return {
                    id_tabela_from: this.idMotivoAtendimento,
                    id_form_formulario: ass.formFormulario.id,
                    uuid_form_formulario: ass.formFormulario.uuid,
                    codigo: ass.formFormulario.idform_formularioerp,
                    titulo: ass.formFormulario.titulo,
                    geral_tabela: 'crm_motivo_atendimento',
                    obrigatorio: false,
                };
            });
        },
        sortTable(field, order) {
            this.column = field;
            this.order = order;
            this.carregarDados(this.pagination.currentPage);
        },
        onSearch(value) {
            this.queryFilter = this.removeAcentos(value);
            this.pagination.currentPage = 1;
            this.carregarDados();
        },
        updatePagination(value) {
            this.pagination.resetPagination = false;
            this.pagination.perPage = value.perPage;
            this.pagination.currentPage = value.currentPage;
            this.carregarDados(value.currentPage);
        },
        save() {
            if (this.formulariosSelecionados.length > 0) {
                this.isLoading = true;

                this.service.save(this.formulariosSelecionados)
                .then(value => {
                    if (value.content === null) {
                        this.msgs.push(new Message("error", `${value.message}`, true));
                    } else {
                        this.$emit('fecharModal', true);
                    }
                })
                .catch((e) => {
                    this.msgs.push(new Message("alert", 'msg-erro-load', true));
                })
                .finally(() => {
                    this.isLoading = false;
                });
            } else {
                this.msgs.push(new Message("error", 'msg-selecione-formulario', true));
                this.isLoading = false;
            }
        },
    },
}
</script>

<style lang="scss" scoped>
#main {
    padding: 20px 20px;

    .search-and-filter {
        .search-bar {
            width: 100%;
        }
        @media (max-width: 760px) {
            .search-bar {
                padding-right: 0;
            }
        }
    }
}
</style>
